import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { IvrService } from '../../../ivr/ivr.service';
import { IvrModel } from '../../../ivr/ivr.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-select-ivr',
  templateUrl: './select-ivr.component.html',
  styleUrls: ['./select-ivr.component.scss']
})
export class SelectIvrComponent implements OnInit {
  @Input() selectedIvr;
  @Input() msisdnId;

  public ivrs$: Observable<IvrModel[]>;
  public isIvrEnabled: boolean;

  private redirectUrl: string;

  constructor(
    private ivrService: IvrService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit() {
    this.ivrs$ = this.ivrService.getIvrs();
    this.isIvrEnabled = !!this.selectedIvr;
    // TODO: Find a better way; wait for the location to get the proper path, e.g. phone-numbers/2/settings
    // instead of just phone-numbers
    setTimeout(() => {
      this.redirectUrl = window.location.pathname;
    }, 0);
  }

  onSelectIvr(selection) {
    this.ivrService.assignIvrToNumber(this.msisdnId, selection.value).subscribe(() => {
      this.translate.get('CHANGES_SAVED').subscribe((res: string) => {
        this.selectedIvr = selection.value;
        this.toastr.success(res);
      });
    });
  }

  onIsIvrEnabledChange(event) {
    this.isIvrEnabled = event;

    if (!this.isIvrEnabled && !!this.selectedIvr) {
      this.ivrService.unassignIvrToNumber(this.msisdnId).subscribe(() => {
        this.selectedIvr = null;
        this.translate.get('CHANGES_SAVED').subscribe((res: string) => {
          this.toastr.success(res);
        });
      });
    }
  }

  goToCreateIvr() {
    this.router.navigateByUrl(`/ivr/add?redirectTo=${this.redirectUrl}&msisdnId=${this.msisdnId}`);
  }
}
